import { render, staticRenderFns } from "./WrongTownshipManage.vue?vue&type=template&id=5a87814c&scoped=true"
import script from "./WrongTownshipManage.vue?vue&type=script&lang=js"
export * from "./WrongTownshipManage.vue?vue&type=script&lang=js"
import style0 from "./WrongTownshipManage.vue?vue&type=style&index=0&id=5a87814c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87814c",
  null
  
)

export default component.exports